import PagedElements from '@/models/paged/pagedelements';
import PurchaseListViewInterface from '@/models/view/purchaselistviewmodel';

export default class PagedPurchases extends PagedElements<PurchaseListViewInterface> {
    constructor(init?: Partial<PagedPurchases>) { super(init); }
}
